export default __webpack_public_path__ + "00008c65284fb6e0f487fc0e54f24325.svg";